export async function myFetch(url, opts):Promise<any> {
    try {
        const response = await fetch(url, opts);
        if (!response.ok) {
            var msg = `HTTP error! ${url} status: ${response.status} ${response.body}`
            console.error(msg + ' ' + opts)
            throw new Error(msg);
        }
        return response.text();
    } catch (error) {
        var msg = `HTTP error! ${url} ${error}`
        console.error(msg);
        throw error;
    }
}

function addHeader(opts, name, value) {
    if (!opts['headers']) {
        opts['headers'] = {};
    }
    opts['headers'][name] = value;
}

export async function secureFetch(url, opts):Promise<any> {
    addHeader(opts, 'Authorization', 'Bearer ' + localStorage.getItem('token'));
    return myFetch(url, opts);
}

export async function secureFetchJson(url, opts={}):Promise<any> {
    addHeader(opts, 'Content-Type', 'application/json');
    const resp = await secureFetch(url, opts);
    return JSON.parse(resp);
}

export async function secureGetJson(url, opts={}):Promise<any> {
    addHeader(opts, 'Content-Type', 'application/json');
    opts['method'] = 'GET';
    const resp = await secureFetch(url, opts);
    return JSON.parse(resp);
}

export async function securePostJson(url, data, opts={}):Promise<any> {
    addHeader(opts, 'Content-Type', 'application/json');
    opts['method'] = 'POST';
    opts['body'] = JSON.stringify(data);
    const resp = await secureFetch(url, opts);
    return JSON.parse(resp);
}

export async function postJson(url, data, opts={}):Promise<any> {
    addHeader(opts, 'Content-Type', 'application/json');
    opts['method'] = 'POST';
    opts['body'] = JSON.stringify(data);
    const resp = await myFetch(url, opts);
    return JSON.parse(resp);
}
